import React, { useContext } from "react";
import "./style.scss";
import { Link } from "react-router-dom";
// import IconFb from '../../../assets/img/icon-fb.png'
// import IconInsta from '../../../assets/img/icon-insta.png'
// import IconLinkedin from '../../../assets/img/icon-linkedin.png'
// import IconTw from '../../../assets/img/icon-tw.png'

import IconFb from "../../../assets/img/redes/Facebook.png";
import IconInsta from "../../../assets/img/redes/Instagram.png";
import IconLinkedin from "../../../assets/img/redes/LinkedIn.png";
import IconTw from "../../../assets/img/redes/Xfooter.svg";

import FooterLocationPin from "../../../assets/img/footer-location-pin.png";
import FooterPhone from "../../../assets/img/footer-phone.png";
// removed unused: FooterBook
import { useToggle } from "../../../utils/useToggle";
import { PoliticaProteccionComponent } from "./politica-proteccion";
import { TerminosCondicionesComponent } from "./terminos-condiciones";
import BrandLogo from "../../brand-logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faBook,
  faCircleXmark,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
import { GlobalContextMemorySpace } from "../../../context/globalContext";

const CommonFooter = (props) => {
  const politicaToggle = useToggle();
  const terminosToggle = useToggle();

  const { footerConfiguration } =
    useContext(GlobalContextMemorySpace);

  function ScrollTop() {
    window.scrollTo({ top: 0, left: 0, beahivor: "smooth" });
  }

  return (
    <section className="section-footer" style={{ minHeight: "200px" }}>
      <div className="container">
        <div className="row pt-3 pb-2">
          
            <div className="col-lg-6">
              <p className="d-flex justify-content-start align-items-center">
                <BrandLogo
                  variant="logoFooter"
                  alt="logo footer"
                  style={{ paddingRight: "5px", height: "16px" }}
                />
                <span className="section-footer__titulo">
                  {" "}
                  {`Hospital Británico | © ${new Date().getFullYear()}`}
                </span>
              </p>

              <p className="section-footer__texto-PSHB">
                  Sr. Consumidor o usuario: ante cualquier duda o reclamo diríjase al área de defensa y protección al consumidor de cualquier Centro de Gestión y participación Comunal (CGPC) del Gobierno de la ciudad Autónoma de Buenos Aires. <br/><br/> R.N.E.M.P N° 1255 -RNAS 9-0250-4 Superintendencia de Servicios de Salud 0800-222-SALUD (72583).{" "}
                <a href="https://www.argentina.gob.ar/sssalud" target="_blank" rel="noreferrer">
                  {" "}
                  www.sssalud.gob.ar{" "}
                </a>{" "}
              </p>
              <p className="section-footer__texto">
                Defensa de las y los consumidores. Para reclamos ingrese{" "}
                <a
                  href="https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario"
                  target="_blank"
                  rel="noreferrer"
                >
                  aquí.
                </a>
              </p>
            </div>
          

          <div className="col-lg-6">
            <div className="d-flex contact-social-networks">
              <div className="icons d-flex align-items-center">
                <a
                  id="socialIcon"
                  href={footerConfiguration?.facebook}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconFb}
                    className="img-fluidd px-1 footer-icon"
                    alt="icon-fb"
                    style={{}}
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfiguration?.twitter}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconTw}
                    className="img-fluidd  px-1 footer-icon"
                    alt="icon-fb"
                    style={{}}
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfiguration?.linkedin}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconLinkedin}
                    className="img-fluidd px-1 footer-icon"
                    alt="icon-fb"
                    style={{}}
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfiguration?.instagram}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconInsta}
                    className="img-fluidd px-1 footer-icon"
                    alt="icon-fb"
                    style={{}}
                  />
                </a>
              </div>
              <div className="section-footer__privacidad">
                <span className="section-footer__texto">
                  <span>
                    <button className="btn" onClick={politicaToggle.onToggle}>
                      POLÍTICA DE PRIVACIDAD
                    </button>
                  </span>

                  <span>
                    {" "}
                    <button className="btn" onClick={terminosToggle.onToggle}>
                      {" "}
                      | TERMINOS Y CONDICIONES
                    </button>
                  </span>

                  <span>
                    {" "}
                    <button className="btn btnPointer">
                      {" "}
                      |{" "}
                      <a
                        target={"_blank"}
                        className="link-default"
                        rel={"noreferrer"}
                        href={footerConfiguration?.intranet}
                      >
                        INTRANET
                      </a>
                    </button>
                  </span>
                </span>
                <PoliticaProteccionComponent
                  visible={politicaToggle.toggle}
                  onToggle={politicaToggle.onToggle}
                />
                <TerminosCondicionesComponent
                  visible={terminosToggle.toggle}
                  onToggle={terminosToggle.onToggle}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="d-flex flex-column mx-2 mt-3 contact-information">
                  <div className="icon-location">
                    <img
                      src={FooterLocationPin}
                      className="img-fluid"
                      alt="icon-fb"
                      style={{}}
                    />
                    <a
                      href={footerConfiguration?.ubicacion}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="ms-2 section-footer__texto">
                        {footerConfiguration?.direccion_domicilio}
                      </span>
                    </a>
                  </div>
                  <div className="icon-phone" style={{ marginTop: "5px" }}>
                    <img
                      src={FooterPhone}
                      className="img-fluid"
                      alt="icon-fb"
                      style={{}}
                    />
                    <a href={footerConfiguration?.telefono_domicilio}>
                      <span className="ms-2 section-footer__texto">
                        {footerConfiguration?.telefono_domicilio}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="d-flex flex-column mx-2 mt-3 contact-information">
                  <div className="icon-book">
                    <FontAwesomeIcon icon={faBook} color="#0f86c3" />                    
                      <span
                        className="ms-2 section-footer__texto"
                        onClick={() => {
                          ScrollTop();
                        }}
                      >
                        <Link to="pages/libro-de-sugerencias">Libro de sugerencias</Link>
                      </span>
                    
                  </div>
                  
                    <>
                      <div className="icon-book">
                        <FontAwesomeIcon icon={faDownload} color="#0f86c3" />
                        <span
                          onClick={() => {
                            ScrollTop();
                          }}
                          className="ms-2 section-footer__texto"
                        >
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href={                              
                              "/pages/baja-plan-salud"
                            }
                          >
                            Solicitud de Baja de Plan de Salud
                          </a>
                        </span>
                      </div>
                      <div className="icon-book">
                        <FontAwesomeIcon icon={faCircleXmark} color="#0f86c3" />
                        <span
                          onClick={() => {
                            ScrollTop();
                          }}
                          className="ms-2 section-footer__texto"
                        >
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href={                              
                              "/pages/tramite-arrepentimiento"
                            }
                          >
                            Trámite de arrepentimiento
                          </a>
                        </span>
                      </div>
                      <div className="icon-book">
                        <FontAwesomeIcon icon={faFile} color="#0f86c3" />
                        <span className="ms-2 section-footer__texto">                          
                          <a href={footerConfiguration?.contrato?.url} target="_blank" rel="noopener noreferrer" download="nombre_pretendido_del archivo.pdf">
                            Contrato de Adhesión
                          </a>
                         
                        </span>
                      </div>
                    </>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonFooter;
